import React, { createContext, useContext, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';

import { SpaceConfiguratorProps } from './types';
import { useMapboxMap } from '@mono/use-mapbox-map';
import { toHash } from '@mono/to-hash';

interface SpaceConfiguratorContextProps extends Omit<SpaceConfiguratorProps, 'onChange' | 'initialState'> {
    state: SpaceConfiguratorProps['initialState'];
    setState: React.Dispatch<React.SetStateAction<SpaceConfiguratorProps['initialState']>>;
    map?: mapboxgl.Map;
    mapRef?: React.MutableRefObject<HTMLDivElement | null>;
}
export const SpaceConfiguratorContext = createContext<SpaceConfiguratorContextProps>({
    state: {
        space: undefined,
        movSiteId: undefined,
        griddedDatasetId: undefined,
        griddedCapabilityId: undefined,
        obsId: undefined,
        obsCapabilityId: undefined,
    },
    setState: () => {},
    map: undefined,
    mapRef: undefined,
});

export const useSpaceConfiguratorContext = () => useContext(SpaceConfiguratorContext);

type SpaceConfiguratorProviderProps = SpaceConfiguratorProps & {
    children: React.ReactNode;
    map?: mapboxgl.Map;
    mapRef?: React.MutableRefObject<HTMLDivElement>;
};

export const SpaceConfiguratorProvider = ({ children, ...props }: SpaceConfiguratorProviderProps) => {
    const [mapRef, map] = useMapboxMap({ cooperativeGestures: true, defaultView: props.initialState.defaultView });
    const [state, setState] = useState(props.initialState);

    useEffect(() => {
        props.onChange(state);
    }, [toHash(state)]);

    return <SpaceConfiguratorContext.Provider value={{ ...props, mapRef, map, state, setState }}>{children}</SpaceConfiguratorContext.Provider>;
};
